<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Syarat & Ketentuan Categories</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Category</b>
      <br />
      <b-row class="mt-4">
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category"
            label-for="input-1"
          >
            <input
              id="input-1"
              placeholder="Category"
              v-validate="'required'"
              v-model="name"
              data-vv-as="Category"
              name="name"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <!-- <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category (English)"
            label-for="input-1"
          >
            <input
              placeholder="Category In English"
              v-validate="'required'"
              v-model="category_en"
              data-vv-as="Category English"
              name="category_en"
              class="form-control"
            />
            <b-form-invalid-feedback
              id="input-category_en-feedback"
            >{{ veeErrors.first('category_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>-->
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >Create</b-button>
          <router-link :to="{name: 'TncCategory'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      title: "",
      name: "",
      category_en: ""
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("name", this.name);
          // formData.append("category_name_en", this.category_en);
          this.$store
            .dispatch("TncCategoryModule/postTncCategory", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "TncCategory" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    }
  }
};
</script>

<style>
</style>
